import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { CallAddCustomPermissionsLink } from '../CallAddCustomPermissionsLink/CallAddCustomPermissionsLink';
import { CallMemberPermissionsItem } from '../CallMemberPermissionsItem/CallMemberPermissionsItem';
import { useCallCustomPermissionsBlockPresenter } from './CallCustomPermissionsBlock.presenter';
import styles from './CallCustomPermissionsBlock.styles.m.css';
import { ICallCustomPermissionsBlockProps } from './CallCustomPermissionsBlock.types';

export const CallCustomPermissionsBlock: FC<ICallCustomPermissionsBlockProps> = observer(
  (props) => {
    const presenter = useCallCustomPermissionsBlockPresenter(props);

    return (
      <>
        <div className={styles.divider} />
        <CallAddCustomPermissionsLink
          call={props.call}
          callController={props.callController}
          popupInstance={props.popupInstance}
          onClose={props.onClose}
        />
        {!!presenter.customPermissions?.size && (
          <>
            {presenter.customPermissionsIds?.map((id) => (
              <CallMemberPermissionsItem
                key={id}
                userId={id}
                call={props.call}
                onClose={props.onClose}
                callController={props.callController}
                popupInstance={props.popupInstance}
              />
            ))}
          </>
        )}
      </>
    );
  }
);
